import API_BASE_URL from "./config";
import { MOCK_MENU_DATA } from './mockMenu'; // Assicurati che il percorso sia corretto

export async function getMenu() {
  if (true) {
    // Ritorna i dati all'istante senza giri strani
  return MOCK_MENU_DATA;
  }

  // Chiamata reale al backend
  const res = await fetch(`${API_BASE_URL}/pizza`);
  if (!res.ok) throw new Error("Menu get error");
  return res.json();
}

export async function postOrder(data) {
  try {
    const res = await fetch(`${API_BASE_URL}/order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw new Error("Order post error");
    }

    return res.json();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getOrders() {
  const res = await fetch(`${API_BASE_URL}/orders`);
  if (!res.ok) throw new Error("Order get error");
  return res.json();
}

export async function getOrder(orderCode) {
  const res = await fetch(`${API_BASE_URL}/order/${orderCode}`);
  if (!res.ok) throw new Error("Order not exist");
  return res.json();
}

export async function patchOrder(data, orderCode) {
  try {
    const res = await fetch(`${API_BASE_URL}/pizza/order/${orderCode}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw new Error("Order post error");
    }

    return res.json();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function patchOrderStatus(orderCode, orderStatusData) {
  try {
    const res = await fetch(`${API_BASE_URL}/order/${orderCode}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(orderStatusData)
    });

    if (!res.ok) {
      throw new Error("Order post error");
    }

    return res.json();
  } catch (err) {
    console.error(err);
    throw err;
  }
}


